import React, { useEffect } from "react";
import { HiChevronRight, HiOutlineSearch } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ImSpinner2 } from "react-icons/im";
import { fetchAutoMessage } from "../../redux/slices/ceoSlice";
import ModalAutoEmailMessage from "../../components/modals/user/ModalAutoEmailMessage";

const UserAutoEmailMessage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAutoMessage());
  }, [dispatch]);

  const autoMessage = useSelector((state) => state.ceo?.autoMessage);
  const status = useSelector((state) => state.ceo?.autoMessageStatus);
  const error = useSelector((state) => state.ceo?.error);

  // Format the autoMessage data to display all three days
  const formattedMessages = autoMessage?.data ? [
    {
      day: "Day 1",
      subject: autoMessage.data.Day1?.subject || "No subject set",
      message: autoMessage.data.Day1?.message || "No message set"
    },
    {
      day: "Day 3", 
      subject: autoMessage.data.Day3?.subject || "No subject set",
      message: autoMessage.data.Day3?.message || "No message set"
    },
    {
      day: "Day 7",
      subject: autoMessage.data.Day7?.subject || "No subject set",
      message: autoMessage.data.Day7?.message || "No message set"
    }
  ] : [];

  

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Auto Email Message
          </h1>

          <div className="flex justify-left items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />
            <p className="text-[14px] text-gray-500  font-medium">Users</p>

            <HiChevronRight className=" text-gray-500" />
            <p className="text-[14px] text-gray-500  font-medium">
              Auto Email Message
            </p>
          </div>
        </div>
      </div>
      <div className="flex mt-4 justify-between mb-4">
        <button className="relative w-72">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <HiOutlineSearch className=" text-gray-500 text-2xl" />
          </div>
        </button>
        <div>
          <ModalAutoEmailMessage />
        </div>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="relative overflow-x-auto rounded-t-lg">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-sm text-gray-700 bg-gray-50 whitespace-nowrap">
              <tr>
                <th className="px-4 py-3 text-left">Day</th>
                <th className="px-4 py-3 text-left">Subject</th>
                <th className="px-4 py-4 text-left">Message</th>
              </tr>
            </thead>
            <tbody className="text-sm text-left">
              {status === "failed" ? (
                <tr>
                  <td colSpan="3" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="3" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : !autoMessage || formattedMessages.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center text-gray-500 py-4">
                    No Auto Email Messages Set
                  </td>
                </tr>
              ) : (
                formattedMessages.map((message, index) => (
                  <tr key={index} className="border-b border-gray-200">
                    <td className="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                      {message.day}
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-4">
                        <textarea
                          value={message.subject}
                          readOnly
                          cols="20"
                          rows="5"
                          className="w-full p-3 rounded-lg bg-gray-100 text-sm resize-none"
                        ></textarea>
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-4">
                        <textarea
                          value={message.message}
                          readOnly
                          cols="20"
                          rows="5"
                          className="w-full p-3 rounded-lg bg-gray-100 text-sm resize-none"
                        ></textarea>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserAutoEmailMessage;